import { ExclamationCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const StyledDashboardErrorBlock = styled("div")`
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    padding: 14px;
    background-color: ${(props) => props.theme.collapseHeaderBackground};
    border-radius: 8px !important;
`;

export const StyledDashboardDangerIcon = styled(ExclamationCircleOutlined)`
    font-size: 24px;
    color: ${(props) => props.theme.dangerTypographyColor};
`;
